<template>
  <div class="notes-component">
    <div class="notes-list" v-show="dataVisibleNotes">
      <question-note-component v-for="note in notes.list"
                               :note="note"
                               @showlist="onClick"
      />
    </div>
    <div class="notes-actions">
        <button type="button" @click="addNote">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" xml:space="preserve">
            <path d="M1.3,17.6l1.2-4.1C2.2,13,2,12.4,1.9,11.8c-0.1-0.6-0.2-1.2-0.2-1.8c0-1.2,0.2-2.2,0.7-3.2c0.4-1,1-1.9,1.8-2.6s1.6-1.3,2.6-1.8c1-0.4,2.1-0.7,3.2-0.7c1.2,0,2.2,0.2,3.2,0.7c1,0.4,1.9,1,2.6,1.8s1.3,1.6,1.8,2.6c0.4,1,0.6,2.1,0.6,3.2c0,1.1-0.2,2.2-0.6,3.2c-0.4,1-1,1.9-1.8,2.6s-1.6,1.3-2.6,1.8c-1,0.4-2.1,0.7-3.2,0.7c-0.6,0-1.2-0.1-1.8-0.2C7.6,18,7,17.8,6.5,17.5l-4.1,1.2c-0.3,0.1-0.6,0-0.9-0.2C1.2,18.2,1.2,18,1.3,17.6z M10,13.3c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6v-1.6h1.6c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.3h-1.6V7.5c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.3S9.6,6.7,9.4,6.9C9.2,7.1,9.1,7.3,9.1,7.5v1.6H7.5c-0.2,0-0.4,0.1-0.6,0.3C6.8,9.5,6.7,9.7,6.7,10s0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3h1.6v1.6c0,0.2,0.1,0.4,0.3,0.6C9.6,13.2,9.8,13.3,10,13.3zM3.4,16.6L6,15.8c0.1,0,0.2,0,0.2-0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.1c0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.8,0,3.4-0.6,4.6-1.9s1.9-2.8,1.9-4.6s-0.6-3.4-1.9-4.6c-1.3-1.3-2.8-1.9-4.6-1.9c-1.8,0-3.4,0.6-4.6,1.9C4.1,6.6,3.5,8.2,3.5,10c0,0.5,0.1,1,0.2,1.4c0.1,0.5,0.3,0.9,0.5,1.4c0.1,0.2,0.1,0.4,0.2,0.6c0,0.2,0,0.4-0.1,0.6L3.4,16.6z"/>
          </svg>
          <div class="button-label-track">
            <div class="button-label-slide">
              <span>{{$t('add-note-for-question')}}</span>
            </div>
          </div>
        </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps, onMounted, reactive, ref } from 'vue';
import QuestionNote from './QuestionNote';
import Manager from '../../../../core/Manager';
import QuestionNoteComponent from './QuestionNoteComponent.vue';
import QuestionNoteCollection from './QuestionNoteCollection';

const props = defineProps<{
  submissionId: string,
  pageId: any
  questionId: any
}>();

const model = ref('');
const submission = Manager.getInstance().submission;
const notes = reactive(new QuestionNoteCollection(props.pageId, props.questionId));

onMounted(() => {
  document.addEventListener('click', onClick);
})

const onClick = () => {
  notes.list.forEach((note) => {
    note.showList = false;
  })
}

const addNote = () => {
  const note = QuestionNote.create(props.submissionId, props.pageId, props.questionId);
  notes.list.push(note);
}

const dataVisibleNotes = computed(() => {
  let count = 0
  notes.list.forEach((note) => {
    if(note.show) {
      count++;
    }
  })
  return Boolean(count);
});

</script>

<style lang="scss">
.extra-item + .notes-component {
  margin-top: 30px;
}
.notes-actions {
  opacity: 0;
  pointer-events: none;
}
panel-element {
  &:hover,
  &:focus-within {
    .notes-actions {
      opacity: 1;
      pointer-events: all;
    }
  }
}
.notes-component {
  display: flex;
  flex-direction: column;
  gap: 15px;
  .notes-actions {
    transition: opacity 300ms;
    button {
      --button-size: 40px;
      --font-size: 12;
      padding: 0;
      min-height: 0;
      width: var(--button-size);
      height: var(--button-size);
      svg {
        position: relative;
        z-index: 2;
        fill: #fff;
      }
      .button-label-track {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        height: 100%;
        white-space: nowrap;
        border-radius: calc(var(--button-size) / 2);
        overflow: hidden;
        pointer-events: none;
      }
      .button-label-slide {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 20px 0 calc(var(--button-size) - 5px);
        border-radius: calc(var(--button-size) / 2);
        background: var(--mc-2022-link-color);
        transform: translateX(calc(var(--button-size) - 100%));
        transition: transform 500ms;
        span {
          opacity: 0;
          transform: translateX(10px);
          transition: opacity 100ms, transform 0ms 100ms;
        }
      }
      &:hover {
        background-color: var(--mc-2022-link-color);
        .button-label-track {
          pointer-events: all;
        }
        .button-label-slide {
          transform: translateX(0);
          span {
            opacity: 1;
            transform: translateX(0);
            transition: opacity 300ms 200ms, transform 300ms 200ms;
          }
        }
      }
    }
  }
  .notes-list {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
  }
}
</style>
